import DebitCardsList from './DebitCardsList';

export default DebitCardsList;
